const api_url = 'https://budgetvenlig.dk/';

export default api_url;
